import { EndpointBindingType, SSOType } from "@app/sso-schemes";

import { SSOAction, SSOActions } from "../actions";
import { SSO, SSOStatus } from "../models";
import { SSOState } from "../states";

export const ssoInitialState: SSOState = {
  //TODO: Use this as the original object to compare the sso property to...to detect unsaved changes
  // if the claim type defaults are changed, also update ClientContext.tsx default variables
  initialSSO: {} as SSO,
  sso: {
    emailClaimType: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress",
    idpSignOnEndpointBindingType: EndpointBindingType.redirect,
    nameIdentifierClaimType: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier",
    ssoType: SSOType.SAML,
  } as SSO,
  status: SSOStatus.Not_Loaded,
};

export const ssoReducer = (state: SSOState, action: SSOActions): SSOState => {
  switch (action.type) {
    case SSOAction.DeleteSSO:
      return Object.freeze({
        ...state,
        status: SSOStatus.Saving,
      });
    case SSOAction.DeleteSSOFailure:
      return Object.freeze({
        ...state,
        status: SSOStatus.Save_Failed,
      });
    case SSOAction.DeleteSSOSuccess:
      return Object.freeze({
        ...ssoInitialState,
      });
    case SSOAction.LoadSSO:
      return Object.freeze({
        ...state,
        status: SSOStatus.Loading,
      });
    case SSOAction.LoadSSOFailure:
      return Object.freeze({
        ...state,
        status: SSOStatus.Load_Failed,
      });
    case SSOAction.LoadSSOSuccess:
      return Object.freeze({
        ...state,
        initialSSO: action.sso,
        sso: action.sso,
        status: SSOStatus.Loaded,
      });
    case SSOAction.MetadataDownloadBegin:
      return Object.freeze({
        ...state,
        status: state.status | SSOStatus.Download_Metadata,
      });
    case SSOAction.MetadataDownloadEnd:
      return Object.freeze({
        ...state,
        status: state.status & ~SSOStatus.Download_Metadata,
      });
    case SSOAction.SaveSSO:
      return Object.freeze({
        ...state,
        status: SSOStatus.Saving,
      });
    case SSOAction.SaveSSOFailure:
      return Object.freeze({
        ...state,
        status: SSOStatus.Save_Failed,
      });
    case SSOAction.SaveSSOSuccess:
      return Object.freeze({
        ...state,
        initialSSO: action.sso,
        sso: action.sso,
        status: SSOStatus.Saved,
      });
    case SSOAction.UpdateSSO:
      return Object.freeze({
        ...state,
        sso: { ...state.sso, [action.propertyKey]: action.propertyValue },
        status: SSOStatus.Not_Saved,
      });
    default:
      throw new Error(`Action ${JSON.stringify} is out of range`);
  }
};
